import { render } from "./NoteTaker.vue?vue&type=template&id=4a3bdd44"
import script from "./NoteTaker.vue?vue&type=script&lang=js"
export * from "./NoteTaker.vue?vue&type=script&lang=js"

import "pdfvuer/dist/pdfvuer.css?vue&type=style&index=0&lang=css&external"
import "./NoteTaker.vue?vue&type=style&index=1&id=4a3bdd44&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__